<template>
  <v-card color="graylight" class="preloader">
    <div class="preloader-brand"></div>
    <div class="preloader-title" v-if="title">{{ title }}</div>
    <div class="preloader-message" v-if="subtitle">{{ subtitle }}</div>
    <div class="text-center">
      <v-progress-circular
        :size="24"
        :width="2"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'Preloader',
  props: ['title', 'subtitle'],
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/fixes.scss';

.preloader {
  display: flex;
  flex-flow: wrap column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 999;
  background-color: $color-background;

  // Brand
  .preloader-brand {
    position: relative;
    z-index: 999;
    width: 48px;
    height: 48px;
    margin: 0 0 24px 0;

    &::after,
    &::before {
      content: '';
      width: 48px;
      height: 48px;
      position: absolute;
      top: 0;
      left: 0;
    }

    &::after {
      z-index: 2;
      background-image: url('~@/assets/images/icon-pautaria.svg');
      background-repeat: no-repeat;
      background-size: contain;
    }

    &::before {
      z-index: 1;
      border-radius: 100%;
      box-shadow: 0 0 0 0 rgba($color-primary, 1);
      transform: scale(1);
      animation: pulse 2s infinite;

      @keyframes pulse {
        0% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 rgba($color-primary, 0.8);
        }

        70% {
          transform: scale(1);
          box-shadow: 0 0 0 10px rgba($color-primary, 0);
        }

        100% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 rgba($color-primary, 0);
        }
      }
    }
  }

  .preloader-title {
    font-size: 2em;
    font-family: 'globotipo' !important;
    font-weight: 300 !important;
    font-style: italic;
    color: $color-black-80;
    line-height: 1em;
    text-align: center;
    margin: 0 0 16px 0;

    ::v-deep span {
      font-family: 'globotipo' !important;
      font-weight: 600 !important;
    }

    @include for-size(phone-only) {
      font-size: 1.4em;
    }
  }

  .preloader-message {
    width: 280px;
    margin: 0 0 16px 0;
    font-size: 0.88em;
    font-style: italic;
    color: $color-black-56;
    line-height: 1.2em;
    text-align: center;
    font-family: 'globotipo' !important;
    font-weight: 400 !important;

    span {
      font-family: 'globotipo' !important;
      font-weight: 600 !important;
    }

    @include for-size(phone-only) {
      font-size: 0.88em;
    }
  }
}
</style>
